import React, { useEffect } from "react";
import "../CareersStyles/ApplicationProcess.css";

const ApplicationProcess = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll('[data-animate]');
    elements.forEach(el => observer.observe(el));

    return () => {
      elements.forEach(el => observer.unobserve(el));
    };
  }, []);

  return (
    <div className="container">
      <div className="left-content" data-animate="slideInLeft">
        <h1>Ready to Join Bellary Info Tech Solutions?</h1>
        <p>
          Bellary Info Tech Soltions is excited to welcome new talent to our team! Join us
          and be part of an innovative and growth-driven environment. Start your
          career with us today and unlock endless opportunities.
        </p>
      </div>
      <div className="right-box" data-animate="slideInRight">
        <h2>Application Process</h2>
        <div className="box-content">
          <h3>Recruitment</h3>
          <h3>Apptitude Round</h3>
          <h3>Technical Round</h3>
          <h3>HR Interview</h3>
        </div>
      </div>
    </div>
  );
};

export default ApplicationProcess;
